export const state = {
  messages: '',
  title: '',
  ranOutSession: false,
}

export const getters = {
  errorConfirmed(state) {
    return !!state.messages && !!state.title
  },
  sessionIsEnded(state) {
    return state.ranOutSession
  },
}

export const mutations = {
  SET_GLOBAL_CONFIRM(state, confirms) {
    state.messages = confirms.msg
    state.title = confirms.title
  },
  RESET_GLOBAL_CONFIRM(state) {
    state.messages = ''
    state.title = ''
    state.ranOutSession = false
  },
  SET_SERVER_RAN_OUT_CONFIRM(state, confirms) {
    state.messages = confirms.msg
    state.title = confirms.title
    state.ranOutSession = true
  },
}

export const actions = {
  reset({ commit }) {
    commit('RESET_GLOBAL_CONFIRM')
  },
}
